import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";

import { 
    Modal, ModalHeader, ModalBody, ModalFooter, Input, Button, 
    Nav, NavItem, NavLink, TabContent, TabPane, Row, Col
} from "reactstrap";

import { areaApi, selectAllAreas } from '../../reducers/areaSlice';
import PosAutosuggest from "./PosAutosuggest";

const AnalyticsPopup = ({ onToggle, onNewAnalytics }) => {
    const [activeTab, setActiveTab] = useState("PoS");
    const [pos, setPos] = useState();
    const [area, setArea] = useState();
    const [template, setTemplate] = useState();
    const [sign, setSign] = useState("");
    const [group, setGroup] = useState("");
    const areas = useSelector((state) => selectAllAreas(state))
    
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(areaApi.fetchAll())
    }, [dispatch])

    // useEffect(() => {
    //     console.log(area, template, sign, group)
    // }, [area, template, sign, group])

    const toggle = (tab) => {
        if (activeTab !== tab) {
          setActiveTab(tab);
        }
    };

    const onModalToggle = () => {
        onToggle()
    }

    const onSave = () => {
        if(onNewAnalytics) {
            let name = "Tutti"

            if(pos) name = pos.company_name
            if(area) name = area.name
            if(template) name = template.name
            if(sign !== "" && group === "") name = name + " (" + sign + ")"
            if(sign === "" && group !== "") name = name + " (" + group + ")"
            if(sign !== "" && group !== "") name = name + " (" + sign + ", " + group + ")"

            onNewAnalytics(name, {
                pos_id: pos ? pos.id : null,
                area_id: area ? area.id : null,
                template_id: template ? template.id : null,
                sign: sign !== "" ? sign : null,
                group: group !== "" ? group : null,
            })
        }
        onToggle()
    }

    return (
        <Modal
            isOpen={true}
            toggle={() => { onModalToggle() }}
        >
            <ModalHeader toggle={() => { onModalToggle() }}>
                <b>Nuovo tracciato</b>
            </ModalHeader>
            <ModalBody>
                <Nav tabs>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === "PoS" })} onClick={() => { toggle("PoS") }} >PdV</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === "Advanced" })} onClick={() => { toggle("Advanced") }} >Avanzato</NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} style={{height: "150px"}}>
                    <TabPane tabId="PoS">
                        <Row className="pt-4">
                            <Col md="12">
                                <span>Punto vendita</span>
                                <PosAutosuggest readOnly={false} pos={pos} onItemSelected={(p) => setPos(p)} />
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="Advanced">
                        <Row className="pt-3">
                            <Col md="6">
                                <span>Area</span>
                                <Input type="select" id="area_id" 
                                    value={area ? area.id : undefined} 
                                    onChange={(e) => setArea(areas.find(area => area.id === parseInt(e.target.value)))} 
                                >
                                    <option key="0" value="0">seleziona un'area</option>
                                    {areas && areas.length > 0 ? areas.map((area) => 
                                        <option key={area.id} value={area.id}>{area.name}</option>
                                    ): null}
                                </Input>
                            </Col>
                            <Col md="6">
                                <span>Template</span>
                                <Input type="select" id="template_id" 
                                    value={template ? template.id : undefined} 
                                    onChange={(e) => setTemplate(area.templates.find(tpl => tpl.id === parseInt(e.target.value)))} 
                                >
                                    <option key="0" value="0">{area && area.templates.length > 0 ? "seleziona un template" : "-"}</option>
                                    {area && area.templates.length > 0 ? area.templates.map((tpl) => 
                                        <option key={tpl.id} value={tpl.id}>{tpl.name}</option>
                                    ): null}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col md="6">
                                <span>Insegna</span>
                                <Input value={sign} onChange={(event) => setSign(event.target.value)} />
                            </Col>
                            <Col md="6">
                                <span>Gruppo</span>
                                <Input value={group} onChange={(event) => setGroup(event.target.value)} />
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </ModalBody>
            <ModalFooter>
                <Button id="new_question_btn" color="primary" style={{whiteSpace: "nowrap"}} onClick={() => { onSave() }} >
                    <span className="fas fa-check"></span> AGGIUNGI
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AnalyticsPopup;